import React from 'react';

import { Switch } from '@/components/ui/switch';

interface IncludePageToggleProps {
  value: boolean;
  loading: boolean;
  disabled: boolean;
  onToggle: (enabled: boolean) => Promise<void>;
}

export function IncludePageToggle({ value, loading, disabled, onToggle }: IncludePageToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch id="include-page" checked={value} onCheckedChange={onToggle} disabled={loading || disabled} />
      <label htmlFor="include-page" className="text-sm text-foreground flex items-center gap-2">
        Include page
        {loading && <div className="animate-spin rounded-full size-3 border-2 border-t-transparent border-primary" />}
      </label>
    </div>
  );
}
